<template>
  <Modal modalType="PDFImport" mayCancel="false" v-on:done="onCancel">
    <h2>Import PDF</h2>
    <form class="PForm" v-on:click.stop novalidate>
      <p class="Form_Section">
        <label class="m-inline" for="pageStart">First page:</label>
        <input
          v-model="pageStart"
          type="number"
          min="1"
          :max="pageEnd"
          step="1"
          id="pageStart"
        />
      </p>
      <p>
        <label class="m-inline" for="pageStart">Last page:</label>
        <input
          v-model="pageEnd"
          type="number"
          :min="pageStart"
          :max="numPages"
          step="1"
          id="pageEnd"
        />
      </p>
      <p class="Form_Section">
        <label class="m-inline" for="scaleString">Scale</label>
        <input
          v-model="scaleString"
          type="number"
          min="0.01"
          :max="scaleMax"
          step="0.5"
          id="scaleString"
        />
      </p>
      <p>Page size: {{ scaledSize.x }}&times;{{ scaledSize.y }} pixels</p>
      <h3>Paging direction</h3>
      <p class="Form_Section">
        <input
          type="radio"
          id="orientation"
          name="orientation"
          value="horizontal"
          v-model="orientation"
        />&nbsp;
        <label class="m-inline" for="orientation">Horizontal &rarr;</label>
        <input
          type="radio"
          id="orientation"
          name="orientation"
          value="vertical"
          v-model="orientation"
        />&nbsp;
        <label class="m-inline" for="orientation">Vertical &darr;</label>
      </p>
    </form>
    <div class="ButtonRow-FlexSpaceBetween">
      <button class="WBMBigButton" v-on:click="onCancel">Cancel</button>
      <button class="WBMBigButton m-primary" v-on:click="confirm">
        Insert
      </button>
    </div>
  </Modal>
</template>

<script lang="ts">
import Vector from "victor";
import { Component, Emit, Prop } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { PDFInfo } from "@/wbcontroller/PDFController";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";
import { GlobalMutations } from "@/store/mutations";

@Component({ components: { Modal } })
export default class PDFImportModal extends WBComponent {
  @Prop() readonly info!: PDFInfo;
  pageStart = "1";
  pageEnd = "1";
  orientation: "horizontal" | "vertical" = "horizontal";
  scaleString = "1";

  get scaleMax(): number {
    return Math.min(16384 / this.info.size.x, 16384 / this.info.size.y);
  }

  get scaleNumber(): number {
    const parsedNumber = parseInt(this.scaleString, 10);
    if (Number.isNaN(parsedNumber)) return 1;
    return Math.min(parsedNumber, this.scaleMax);
  }

  get scaledSize(): Vector {
    return this.info.size.clone().multiplyScalar(this.scaleNumber);
  }

  get numPages(): number {
    return this.info.numPages;
  }

  mounted() {
    if (!this.info) {
      debugger;
      return;
    }
    this.pageEnd = `${Math.min(10, this.info.numPages)}`;
  }

  @Emit("cancel")
  onCancel() {
    ModalMutations.closeModals(this.$store.commit);
    GlobalMutations.finishInsertingPDF(this.$store.commit);
  }

  confirm() {
    const parsedStart = Math.max(1, parseInt(this.pageStart, 10));
    const parsedEnd = Math.max(1, parseInt(this.pageEnd, 10));
    this.wbcontroller?.finishInsertingPDF(
      this.info,
      Math.min(parsedStart, this.numPages, parsedEnd),
      Math.min(parsedEnd, this.numPages),
      this.scaleNumber,
      this.orientation
    );
    ModalMutations.closeModals(this.$store.commit);
    GlobalMutations.finishInsertingPDF(this.$store.commit);
  }
}
</script>

<style scoped lang="scss">
input[type="number"] {
  max-width: 4em;
}

.Form_Section {
  line-height: 1em;
  margin-top: 0;
}
</style>
